import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedComponents } from '../../../../components/shared.module';
import { MaterialModule } from '../../../../core/shared/material.module';

@Component({
  selector: 'app-test-caes-panel-view',
  standalone: true,
  imports: [CommonModule, MaterialModule, ...SharedComponents],
  templateUrl: './test-caes-panel-view.component.html',
  styleUrl: './test-caes-panel-view.component.scss'
})
export class TestCaesPanelViewComponent {
  
 @Output() onEventEmit = new EventEmitter();

  @Input()
  data: any = {};

  @Input()
  actions: any = [];

  displayActions = false;

  /**
   * Handles the click event on the card.
   * Emits an event with the type 'view' and the associated card data.
   */
  onDownload() {
    this.onEventEmit.emit({
      type: "download",
      params: this.data,
    });
  }
}
